export default __webpack_public_path__ + "static/media/640_business06-nl-mobile.4a38803c.png";